$( document ).ready(function() {

  /*******************************************************************************
   *  Site Header Scroll Behavior
   ******************************************************************************/

  var scrollPos = 0;
  var scrollPosTop = 0;
  var scrollPosBottom = 0;

  document.addEventListener("scroll", (event) => {

    if(window.scrollY < 120) {
      showFullHeader();
      scrollPosTop = window.scrollY;
      scrollPosBottom = window.scrollY;
    } else {
      if(scrollPos < window.scrollY) {
        // User is scrolling down

        if(
            // User has to scroll down 100 pixels to trigger
            scrollPosBottom <= window.scrollY
            && window.scrollY - scrollPosBottom > 100
        ) {
          showScrollHeader();
        }

        scrollPosTop = window.scrollY;
      } else {
        // User is scrolling up

        if(
            // User has to scroll up 200 pixels to trigger
            scrollPosTop >= window.scrollY
            && scrollPosTop - window.scrollY > 200
        ) {
          showFullHeader();
        }

        scrollPosBottom = window.scrollY;
      }
    }

    scrollPos = window.scrollY;
  });

  function showFullHeader() {
    if($('#topnavbar').hasClass('scrolled')) {
      $('#topnavbar').removeClass('scrolled');
    }
    hideMobileNav();
  }

  function showScrollHeader() {
    if(!$('#topnavbarr').hasClass('scrolled')) {
      $('#topnavbar').addClass('scrolled');
    }
    hideMobileNav();
  }

  function hideMobileNav() {
    // hide navigation if scrolled while mobile nav is visible
    if($('#navbar-toggler-main-menu').hasClass('show')) {
      $('#navbar-toggler-main-menu').removeClass('show');
    }
  }

});
